export default "__VITE_ASSET__oZI31vGW__"